module.exports = __webpack_public_path__ + "static/img/product_img_02.5c9358a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_img_02.png
// module id = POCR
// module chunks = 0